import { useQuery } from "@apollo/client";

import { consoleInventoryForecast } from "./queries";
import { REFRESH_INTERVAL_MS } from "../constants";

/*
 * Per-day occupancy forecast over one date range, for one lot or for the whole
 * installation (lotId null).
 *
 * Polls on the same cadence as the rest of the dashboard: bookings land while
 * the desk is looking at the panel, and a forecast that is a shift out of date
 * is worse than no forecast at all.
 */
export default function useInventoryForecast({ lotId, startDate, endDate }) {
  const { data, loading, error, refetch } = useQuery(consoleInventoryForecast, {
    variables: { lotId: lotId ?? null, startDate, endDate },
    skip: !startDate || !endDate,
    fetchPolicy: "cache-and-network",
    pollInterval: REFRESH_INTERVAL_MS,
  });

  const forecast = data?.consoleInventoryForecast ?? null;

  return {
    forecast,
    days: forecast?.days ?? [],
    loading: loading && !forecast,
    error,
    refetch,
  };
}
